// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import { Message } from 'element-ui'
import ajaxapi from '../api/api'
import { isSign } from '../utils/utils.js'
Vue.use(VueRouter)

// ==================== 定义路由 ====================
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
      icon: 'el-icon-user',
      noAuth: true
    }
  },
  {
    path: '/ProductNotice',
    name: 'ProductNotice',
    component: () => import('@/views/ProductNotice/index.vue'),
    meta: {
      title: '产品使用规范告知书',
      noAuth: true
    }
  },

  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/common/errorPage/404.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/401',
    name: 'Unauthorized',
    component: () => import('@/views/common/errorPage/401.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/panorama',
        name: 'panorama',
        component: () => import('@/views/dataDashboard/panorama.vue'),
        meta: {
          title: '首页驾驶舱',
          icon: 'el-icon-s-grid',
          requiresAuth: true,
          fullScreen: true  // 标记该页面不需要边距
        },
      },
      {
        path: '/editPassWord',
        name: 'editPassWord',
        component: () => import('@/views/login/editPassWord.vue'),
        meta: {
          title: '修改密码',
          icon: 'el-icon-user',
          noAuth: false
        }
      },
      {
        path: 'promoPage',
        name: 'advertisement',
        component: () => import('@/views/advertisement/index.vue'),
        meta: {
          title: '定制方案',
          requiresAuth: false
        },
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: '项目检索',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
        meta: {
          title: '联系人',
          icon: 'el-icon-user',
          requiresAuth: true
        },
      },
      {
        path: 'constructionIndustry',
        name: 'constructionIndustry',
        component: () => import('@/views/constructionIndustry/index.vue'),
        meta: {
          title: '建筑行业数据',
          icon: 'el-icon-coin',
          requiresAuth: true
        },
      },
      {
        path: 'enterpriseDetail',
        name: 'enterpriseDetail',
        component: () => import('@/views/commonDetail/enterpriseDetail.vue'),
        meta: {
          title: '建设单位详情',
          icon: 'el-icon-coin',
          requiresAuth: true
        },
      },
      {
        path: 'enterpriseDetail2',
        name: 'enterpriseDetail2',
        component: () => import('@/views/commonDetail/enterpriseDetail2.vue'),
        meta: {
          title: '建设单位详情测试',
          icon: 'el-icon-coin',
          requiresAuth: true
        },
      },
      {
        path: 'constructionProject',
        name: 'constructionProject',
        component: () => import('@/views/constructionProject/index.vue'),
        meta: {
          title: '建设单位',
          icon: 'el-icon-coin',
          requiresAuth: true
        },
      },
      {
        path: 'constructionProject/detail',
        name: 'constructionProjectDetail',
        component: () => import('@/views/constructionProject/detail.vue'),
        meta: {
          title: '建设单位详情',
          icon: 'el-icon-coin',
          requiresAuth: true
        },
      },
      {
        path: '/contact/detail',
        name: 'contactDetail',
        component: () => import('@/views/contact/detail.vue'),
        meta: {
          title: '联系人详情',
          icon: 'el-icon-user',
          requiresAuth: true
        },
      },
      {
        path: '/ExamineNotice/detail',
        name: 'ExamineNotice',
        component: () => import('@/views/dashboard/ExamineNotice/detail.vue'),
        meta: {
          title: '审批项目详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/ApprovalNotice/detail',
        name: 'ApprovalNotice',
        component: () => import('@/views/dashboard/ApprovalNotice/detail.vue'),
        meta: {
          title: '项目核准详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/RecordPublic/detail',
        name: 'RecordPublic',
        component: () => import('@/views/dashboard/RecordPublic/detail.vue'),
        meta: {
          title: '项目备案详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/EnergyNotice/detail',
        name: 'EnergyNotice',
        component: () => import('@/views/dashboard/EnergyNotice/detail.vue'),
        meta: {
          title: '节能审查详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/LandPreapproval/detail',
        name: 'LandPreapproval',
        component: () => import('@/views/dashboard/LandPreapproval/detail.vue'),
        meta: {
          title: '用地预审详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/LandPermit/detail',
        name: 'LandPermit',
        component: () => import('@/views/dashboard/LandPermit/detail.vue'),
        meta: {
          title: '用地规划许可详情',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/ConstructionPermit/detail',
        name: 'ConstructionPermit',
        component: () => import('@/views/dashboard/ConstructionPermit/detail.vue'),
        meta: {
          title: '工程规划许可',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/EiaReport/detail',
        name: 'EiaReport',
        component: () => import('@/views/dashboard/EiaReport/detail.vue'),
        meta: {
          title: '环境评价',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/landSearch/detail',
        name: 'landSearchDetail',
        component: () => import('@/views/dashboard/landSearch/detail.vue'),
        meta: {
          title: '项目拿地',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/buildPermit/detail',
        name: 'buildPermit',
        component: () => import('@/views/dashboard/buildPermit/detail.vue'),
        meta: {
          title: '施工许可',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: '/tenderingBidding/detail',
        name: 'tenderingBidding',
        component: () => import('@/views/dashboard/tenderingBidding/detail.vue'),
        meta: {
          title: '招投标',
          icon: 'el-icon-search',
          requiresAuth: true
        },
      },
      {
        path: 'chain',
        name: 'chain',
        component: () => import('@/views/chain/index.vue'),
        meta: {
          title: '产业链',
          icon: 'el-icon-location',
          requiresAuth: true
        }
      },
      {
        path: 'monitoring',
        name: 'Monitoring',
        component: () => import('@/views/monitoring/index.vue'),
        meta: {
          title: '重点监测',
          icon: 'el-icon-location',
          requiresAuth: true
        }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: {
          title: '统计分析',
          icon: 'el-icon-data-analysis',
          requiresAuth: true
        }
      },
      {
        path: 'totalEnterprises',
        name: 'totalEnterprises',
        component: () => import('@/views/enterprise/totalEnterprises.vue'),
        meta: {
          title: '全部企业库',
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'enterpriseList',
        name: 'enterpriseList',
        component: () => import('@/views/enterprise/enterpriseList.vue'),
        meta: {
          title: '企业库',
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'enterpriseTag',
        name: 'enterpriseTag',
        component: () => import('@/views/enterprise/tagSearch.vue'),
        meta: {
          title: '标签概念搜索',
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'totalSearch',
        name: 'totalSearch',
        component: () => import('@/views/enterprise/totalSearch.vue'),
        meta: {
          title: '企业搜索',
          icon: 'el-icon-office-building',
          requiresAuth: true
        }
      },
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/report/index.vue'),
        meta: {
          title: '研究报告',
          icon: 'el-icon-document',
          requiresAuth: true
        }
      },
      {
        path: 'calculator',
        name: 'Calculator',
        component: () => import('@/views/calculator/index.vue'),
        meta: {
          title: '关系计算器',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      // {
      //   path: 'investDetail',
      //   name: 'investDetail',
      //   component: () => import('@/views/investStatistics/detail.vue'),
      //   meta: {
      //     title: '投资项目库详情',
      //     icon: 'el-icon-s-grid',
      //     requiresAuth: true
      //   }
      // },
      {
        path: 'investStatistics',
        name: 'investStatistics',
        component: () => import('@/views/investStatistics/investStatistics.vue'),
        meta: {
          title: '投资项目库',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'investSearch',
        name: 'investSearch',
        component: () => import('@/views/investStatistics/investSearch.vue'),
        meta: {
          title: '投资项目库',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'landStatistics',
        name: 'landStatistics',
        component: () => import('@/views/landStatistics/index.vue'),
        meta: {
          title: '拿地项目统计',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'agencyService',
        name: 'agencyService',
        component: () => import('@/views/agencyService/index.vue'),
        meta: {
          title: '产业链上游项目',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'agencyService/detail',
        name: 'agencyServiceDetail',
        component: () => import('@/views/agencyService/detail.vue'),
        meta: {
          title: '产业链上游项目详情',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'agencyService/detailSZ',
        name: 'agencyServiceDetailSZ',
        component: () => import('@/views/agencyService/detailSZ.vue'),
        meta: {
          title: '产业链上游项目深圳详情',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'agencyService/detailGD',
        name: 'agencyServiceDetailGD',
        component: () => import('@/views/agencyService/detailGD.vue'),
        meta: {
          title: '产业链上游项目工程建设详情',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        }
      },
      {
        path: 'projectManagement',
        name: 'projectManagement',
        component: () => import('@/views/projectManagement/index.vue'),
        meta: {
          title: '项目管理',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        },
      },
      {
        path: 'projectDetail',
        name: 'projectDetail',
        component: () => import('@/views/projectManagement/detail.vue'),
        meta: {
          title: '项目管理详情',
          icon: 'el-icon-s-grid',
          requiresAuth: true
        },
      },


    ]
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 白名单路由
const whiteList = ['/login', '/404', '/401']

// 检查登录状态
const checkLogin = () => {
  try {
    const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData')
    if (!userData) return false
    const parsedData = JSON.parse(userData)
    return !!(parsedData && parsedData.token)
  } catch (error) {
    console.error('解析 localStorage 中的 userData 失败:', error)
    return false
  }
}

// ✅ 获取签约状态（带 sessionStorage 缓存）
const getSignStatus = async () => {
  const cached = sessionStorage.getItem('productNoticeSigned')
  if (cached !== null) {
    return cached === 'true'
  }
  try {
    const res = await isSign();
    console.log('签约状态接口返回:', res);
    sessionStorage.setItem('productNoticeSigned', res ? 'true' : 'false')
    return res
  } catch (error) {
    console.error('获取签约状态失败:', error)
    sessionStorage.setItem('productNoticeSigned', 'false')
    return false
  }
}

// ✅ 清除签约状态缓存
export const clearSignCache = () => {
  sessionStorage.removeItem('productNoticeSigned')
}

// ==================== 路由守卫 ====================

router.beforeEach(async (to, from, next) => {
  console.log('路由跳转:', from.path, '->', to.path);

  if (to.meta.title) {
    document.title = to.meta.title + ' - 智瞰平台';
  }

  // 白名单直接放行
  if (whiteList.includes(to.path)) {
    return next();
  }

  // 检查登录
  var isAuthenticated = checkLogin();
  if (!isAuthenticated) {
    if (Message) Message.warning('请先登录！');
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }

  // 已登录访问登录页，跳首页
  if (to.path === '/login') {
    return next({ path: '/' });
  }

  // ✅ 访问签约页本身
  if (to.path === '/ProductNotice') {
    try {
      var signed = await getSignStatus();
      console.log('访问签约页，签约状态:', signed);
      if (signed) {
        return next({ path: '/' });
      }
      return next();
    } catch (err) {
      return next();
    }
  }

  // ✅ 访问其他页面：检查是否已签约
  try {
    var signed = await getSignStatus();
    console.log('访问其他页面，签约状态:', signed);
    if (!signed) {
      if (Message) Message.warning('请先签署产品使用规范告知书！');
      return next({
        path: '/ProductNotice',
        query: { redirect: to.fullPath }
      });
    }
  } catch (err) {
    console.error('签约状态检查失败:', err);
  }

  next();
});

router.afterEach((to, from) => {
  // 页面访问统计等
})

export default router